module.exports = __webpack_public_path__ + "static/media/pf_item_11.5ed60511.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pf_item_11.jpg
// module id = 148
// module chunks = 0